import React from 'react';
import CSSModules from 'react-css-modules';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';
import styles from './RichUpdatesItemShareAlert.scss';
import { sendEvent } from 'src/helpers/api/analytics';
import { generateHash } from 'src/helpers/hashId';

interface Props {
  updateId: number;
  message?: string;
  type: string;
}

const RichUpdatesItemShareAlert: React.StatelessComponent<Props> = ({
  updateId,
  message,
  type,
}) => {
  const shareHash = generateHash();

  const onFacebookShare = () => {
    sendEvent({
      pageType: 'crowdfunding page',
      eventName: 'click',
      subtype: 'button',

      properties: {
        event_value: 'share to facebook',
        page_section: `update > ${type}`,
        social_type: 'feed',
        activity_type: 'crowdfunding_guid',
        social_utm_term: shareHash,
      },
    });
  };

  return (
    <div className={styles.container}>
      <p className="jg-text--regular">Spread the word even further</p>
      <p className="jg-space-mbmd">The more you share the more you raise!</p>
      <div className={styles['facebook-container']}>
        <FacebookShare
          customStyle="jg-btn jg-btn--facebook"
          isActive
          isUpdate
          location="updates"
          buttonText="Share on Facebook"
          updateId={updateId}
          quote={message}
          shareOnFacebookOpened={onFacebookShare}
          shareHash={shareHash}
        />
      </div>
    </div>
  );
};

export default CSSModules(RichUpdatesItemShareAlert, styles);



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.tsx